var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":{name:'Home'}}},[_c('img',{attrs:{"src":_vm.$store.state.webConfig.web_logo}})])],1),_c('div',{staticClass:"login-main"},[_c('StudentLogin'),_c('div',{staticClass:"back"})],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }